import { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSun, faMoon, faBars, faTimes, faPhone } from '@fortawesome/free-solid-svg-icons';
import logo_telec from '../img/logo.png';

const menuItems = [
  { displayText: 'Accueil', href: '#container' },
  { displayText: 'Présentation', href: '#presentation' },
  { displayText: 'Services', href: '#competences' },
  { displayText: 'Réalisations', href: '#projects' },
  { displayText: 'Contact', href: '#contact' },
  { displayText: 'Devis', href: '#devis' },
];

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [theme, setTheme] = useState('light');

  useEffect(() => {
    const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
    const storedTheme = localStorage.getItem('theme');
    const activeTheme = storedTheme || (prefersDark ? 'dark' : 'light');

    setTheme(activeTheme);
    document.documentElement.classList.toggle('dark', activeTheme === 'dark');
  }, []);

  const toggleTheme = () => {
    const newTheme = theme === 'dark' ? 'light' : 'dark';
    setTheme(newTheme);
    localStorage.setItem('theme', newTheme);
    document.documentElement.classList.toggle('dark', newTheme === 'dark');
  };

  const toggleMenu = () => setMenuOpen((v) => !v);

  return (
      <header
          id="header"
          className="bg-light-secondary dark:bg-stone-900 p-6 sticky top-0 z-50"
      >
        <div className="flex items-center justify-between flex-wrap">
          <div className="flex items-center gap-4">
            <a href="#container" aria-label="Retour à l'accueil">
              <img
                  className="w-24 h-12"
                  src={logo_telec}
                  alt="T.ELEC - Électricien à Nancy"
              />
            </a>

            <button
                type="button"
                className="flex items-center gap-2 cursor-pointer"
                onClick={toggleTheme}
                aria-label="Basculer le thème"
            >
              <FontAwesomeIcon
                  icon={theme === 'dark' ? faMoon : faSun}
                  className="text-white w-5 h-5"
              />
              <span className="text-white">
              {theme === 'dark' ? 'Thème sombre' : 'Thème clair'}
            </span>
            </button>
          </div>

          <div className="hidden sm:flex items-center gap-4">
            <a
                href="tel:+33624342947"
                className="text-white font-semibold inline-flex items-center gap-2 hover:opacity-90 transition"
                aria-label="Appeler T.ELEC"
            >
              <FontAwesomeIcon icon={faPhone} />
              <span>06 24 34 29 47</span>
            </a>
          </div>

          <button
              type="button"
              className="sm:hidden text-white text-2xl"
              onClick={toggleMenu}
              aria-label={menuOpen ? 'Fermer le menu' : 'Ouvrir le menu'}
              aria-expanded={menuOpen}
              aria-controls="main-navigation"
          >
            <FontAwesomeIcon icon={menuOpen ? faTimes : faBars} />
          </button>

          <nav
              id="main-navigation"
              aria-label="Navigation principale"
              className={`
            ${menuOpen ? 'block' : 'hidden'}
            w-full sm:flex sm:w-auto sm:items-center sm:gap-6
          `}
          >
            <ul className="flex flex-col sm:flex-row max-sm:text-center gap-3 mt-4 sm:mt-0">
              {menuItems.map((menuItem) => (
                  <li key={menuItem.href}>
                    <a
                        className="inline-block text-gray-200 hover:text-light-primaryHover transition ease-in-out hover:-translate-y-1 hover:scale-110 duration-300"
                        href={menuItem.href}
                        onClick={() => setMenuOpen(false)}
                    >
                      {menuItem.displayText}
                    </a>
                  </li>
              ))}

              <li className="sm:hidden pt-2">
                <a
                    href="tel:+33624342947"
                    className="inline-flex items-center justify-center gap-2 text-white font-semibold"
                    aria-label="Appeler T.ELEC"
                    onClick={() => setMenuOpen(false)}
                >
                  <FontAwesomeIcon icon={faPhone} />
                  <span>06 24 34 29 47</span>
                </a>
              </li>
            </ul>
          </nav>
        </div>
      </header>
  );
};

export default Header;